export default {
  CONNECT_SOCKET_TO_SERVER: 'CONNECT_SOCKET_TO_SERVER',
  LISTEN_EVENT: 'LISTEN_EVENT',
  SUBSCRIBE_CHANNEL: 'SUBSCRIBE_CHANNEL',
  UNSUBSCRIBE_CHANNEL: 'UNSUBSCRIBE_CHANNEL',
  RECONNECT_SOCKET_TO_SERVER: 'RECONNECT_SOCKET_TO_SERVER',
};
